export function castToAny(value: unknown): any {
  return value as any;
}
